import styles from './style.detail.css'
import TransactionDetailReceipt from 'components/receipt/transactions/TransactionDetailReceipt'

class FeedbackReceipt extends React.Component {
  render () {
    let {transactionDetail} = this.props

    return (transactionDetail &&
      <div className='col-sm-6' id='mk-col-right'>
        <div className='mk-col-right-box'>
          <div className={`${styles['scrolled-area']} feedback-scrolled-area`}>
            <TransactionDetailReceipt paymentDetail={transactionDetail} />
            <div className={styles['bottom-separator']} />
            <div className={`${styles['receipt-action-bottom']} feedback-receipt-action-bottom`}>
              <button
                className='btn btn-primary pull-right'
                id='btn-close'
                onClick={this._hideDetail}>
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  _hideDetail = () => {
    $('#customer-feedback').show()
    $('#customer-feedback-detail').hide()
  }
}

FeedbackReceipt.propTypes = {
  transactionDetail: React.PropTypes.object
}

export default FeedbackReceipt



// WEBPACK FOOTER //
// ./app/pages/Customers/Feedback/FeedbackDetail/FeedbackReceipt.js